<div class="content-container">
  <div class="d-flex select-view-buttons flex-33">
    <button
      mat-flat-button
      [ngClass]="
        selectedView === SELECTABLE_VIEWS.PLACER_TOUR_LIST_VIEW
          ? 'active'
          : 'inactive'
      "
      (click)="setSelectedView(SELECTABLE_VIEWS.PLACER_TOUR_LIST_VIEW)"
    >
      Opdrachten
    </button>
    <button
      mat-flat-button
      [ngClass]="
        selectedView === SELECTABLE_VIEWS.PLACER_TOUR_MAP_VIEW
          ? 'active'
          : 'inactive'
      "
      (click)="setSelectedView(SELECTABLE_VIEWS.PLACER_TOUR_MAP_VIEW)"
    >
      Map
    </button>
  </div>
  <div class="upper-space">
    <div *ngIf="selectedView === SELECTABLE_VIEWS.PLACER_TOUR_LIST_VIEW">
      <div *ngIf="taskList === EMPTY_OBJECT" style="align-self: center">
        <mat-spinner
          style="margin: auto"
          color="primary"
          diameter="24"
        ></mat-spinner>
      </div>
      <div
        *ngIf="taskList == null || taskList.tasks?.length === 0"
        class="center-text"
      >
        Geen uit te voeren projecten op deze dag
      </div>
      <div
        *ngIf="taskList != null && taskList.tasks?.length > 0"
        class="task-list flex-vertical"
      >
        <div
          *ngFor="let task of taskList.tasks; trackBy: trackById"
          class="task-block clickable"
          [ngClass]="task.executedClass"
          (click)="openTask(task)"
        >
          <ng-container *ngIf="task.type === 'SubProjectTask'">
            <div class="task-block-row row-flex-3">
              <div class="task-block-column-4">
                <div class="strong block-text">
                  #{{ task.subProject.project.id }}
                </div>
                <div
                  class="strong block-text"
                  [matTooltip]="task.companiesDisplay"
                >
                  {{ task.companiesDisplay | shortenText : 30 }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div class="block-text">{{ task.addressLine1 }}</div>
                <div
                  class="block-text"
                  *ngIf="
                    task.addressLine2 != null && task.addressLine2.length > 0
                  "
                >
                  {{ task.addressLine2 }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div
                  class="strong block-text"
                  *ngIf="task.subProject.project.products?.length > 0"
                >
                  {{
                    task.subProject.project.products[0].type
                      | abbreviatedProductType
                        : task.subProject.project.products[0].otherProductName
                      | shortenText : 30
                  }}
                </div>
                <div
                  class="strong block-text"
                  *ngIf="task.subProject.project.products?.length > 0"
                >
                  {{ task.subProject.project.products[0].overviewFormat }}
                </div>
                <div
                  class="strong block-text"
                  *ngIf="task.boardTypeAndPlacement?.length > 0"
                >
                  {{ task.boardTypeAndPlacement }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div class="subproject-type d-flex">
                  <div
                    class="project-type type-flex"
                    [ngClass]="task.executedIconClass"
                  >
                    {{
                      task.subProject.type
                        | overviewProjectType
                          : task.subProject.status
                          : task.subProject.withPlacement
                    }}
                  </div>
                  <div class="type-rest-flex"></div>
                </div>
              </div>
            </div>
            <div class="task-block-row row-flex-6">
              <div
                class="appointment-margin d-flex"
                [matTooltip]="
                  task.subProject.projectPlacement.needAppointmentInfo
                "
                [matTooltipDisabled]="
                  !task.subProject.projectPlacement.appointment ||
                  task.subProject.projectPlacement.needAppointmentInfo ==
                    null ||
                  task.subProject.projectPlacement.needAppointmentInfo
                    .length === 0
                "
              >
                <mat-icon
                  class="appointment-icon"
                  svgIcon="{{ task.appointmentIcon }}"
                ></mat-icon>
                <div class="appointment-text block-text">
                  <span>{{ task.appointmentText }}</span>
                  <span
                    *ngIf="
                      task.subProject.projectPlacement.appointment &&
                      (task.subProject.projectPlacement.appointmentDate !=
                        null ||
                        task.subProject.projectPlacement.appointmentTime)
                    "
                    >{{
                      task.subProject.projectPlacement.appointmentDate
                        | displayDateTime
                          : task.subProject.projectPlacement.appointmentTime
                          : 'DD/MM'
                          : 'HH:mm'
                          : true
                    }}</span
                  >
                  <span
                    class="block-text"
                    *ngIf="
                      task.subProject.projectPlacement.appointment &&
                      task.subProject.projectPlacement.needAppointmentInfo
                        ?.length > 0
                    "
                    >:
                    <span class="secondary-color">{{
                      task.subProject.projectPlacement.needAppointmentInfo
                        | shortenText : 60
                    }}</span></span
                  >
                </div>
              </div>
            </div>
            <div class="task-block-row row-flex-3">
              <div class="task-block-column-0-75">
                <div *ngIf="task.placerNotes?.length > 0">
                  <span
                    class="strong block-text notes-label"
                    [ngClass]="task.executedClass"
                    >Opmerkingen: </span
                  ><span class="block-text" [matTooltip]="task.placerNotes">{{
                    task.placerNotes | shortenText : 50
                  }}</span>
                </div>
              </div>
              <div class="task-block-column-0-25">
                <div class="executed-display">
                  <div class="executed-queue-icon">
                    <div
                      *ngIf="task.submitQueued && !task.submitInProgress"
                      matTooltip="Taak staat klaar om ingediend te worden"
                    >
                      <mat-icon class="queue-icon">cloud_queue</mat-icon>
                    </div>
                    <div
                      *ngIf="task.submitInProgress"
                      matTooltip="Taak wordt ingediend"
                    >
                      <mat-spinner
                        class="submitting-icon"
                        color="primary"
                        diameter="20"
                      ></mat-spinner>
                    </div>
                  </div>
                  <div class="executed-string">
                    <span
                      *ngIf="task.executedTimeString?.length > 0"
                      class="strong"
                      >{{ task.executedTimeString }}</span
                    >
                  </div>
                  <div class="executed-circle">
                    <mat-icon svgIcon="{{ task.executedCircle }}"></mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="task.type === 'OtherTask'">
            <div class="task-block-row row-flex-3">
              <div class="task-block-column-4">
                <div class="strong block-text">
                  {{ task.title }}
                </div>
              </div>
              <div class="task-block-column-4"></div>
              <div class="task-block-column-4">
                <div class="strong block-text">
                  {{
                    task.timeBudgetDisplay?.length > 0
                      ? task.timeBudgetDisplay + ' min.'
                      : ''
                  }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div class="subproject-type d-flex">
                  <div
                    class="project-type type-flex"
                    [ngClass]="task.executedIconClass"
                  >
                    Taak
                  </div>
                  <div class="type-rest-flex"></div>
                </div>
              </div>
            </div>
            <div class="task-block-row row-flex-3 smaller-upper-space">
              <div class="task-block-column-0-75">
                <div *ngIf="task.description?.length > 0">
                  <span
                    class="strong block-text notes-label"
                    [ngClass]="task.executedClass"
                    >Omschrijving: </span
                  ><span class="block-text" [matTooltip]="task.description">{{
                    task.description | shortenText : 50
                  }}</span>
                </div>
              </div>
              <div class="task-block-column-0-25">
                <div class="executed-display">
                  <div class="executed-queue-icon">
                    <div
                      *ngIf="task.submitQueued && !task.submitInProgress"
                      matTooltip="Taak staat klaar om ingediend te worden"
                    >
                      <mat-icon class="queue-icon">cloud_queue</mat-icon>
                    </div>
                    <div
                      *ngIf="task.submitInProgress"
                      matTooltip="Taak wordt ingediend"
                    >
                      <mat-spinner
                        class="submitting-icon"
                        color="primary"
                        diameter="20"
                      ></mat-spinner>
                    </div>
                  </div>
                  <div class="executed-string">
                    <span
                      *ngIf="task.executedTimeString?.length > 0"
                      class="strong"
                      >{{ task.executedTimeString }}</span
                    >
                  </div>
                  <div class="executed-circle">
                    <mat-icon svgIcon="{{ task.executedCircle }}"></mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="task.type === 'LoadTask'">
            <div class="task-block-row row-flex-3">
              <div class="task-block-column-4">
                <div class="strong block-text">
                  #{{ task.subProject.project.id }}
                </div>
                <div
                  class="strong block-text"
                  [matTooltip]="task.companiesDisplay"
                >
                  {{ task.companiesDisplay | shortenText : 30 }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div class="block-text">
                  <span class="strong">Plaatsingsdatum: </span>
                  <span>{{ task.placementDateDisplay }}</span>
                </div>
                <div class="block-text">
                  <span class="strong">Laadtijdstip: </span>
                  <span
                    >{{
                      task.startTime | appSubstring : 0 : 5 | or : '__:__'
                    }}u</span
                  >
                </div>
                <div class="block-text">
                  <span class="strong">Laadtijd: </span>
                  <span>{{ task.timeBudgetDisplay }} min</span>
                </div>
              </div>
              <div class="task-block-column-4">
                <div
                  class="strong block-text"
                  *ngIf="task.displayProduct != null"
                >
                  {{
                    task.displayProduct.type
                      | abbreviatedProductType
                        : task.displayProduct.otherProductName
                      | shortenText : 30
                  }}
                </div>
                <div
                  class="strong block-text"
                  *ngIf="task.displayProduct?.overviewFormat?.length > 0"
                >
                  {{ task.displayProduct.overviewFormat }}
                </div>
                <div
                  class="strong block-text"
                  *ngIf="
                    task.displayProduct?.overviewPlacementDetail?.length > 0
                  "
                >
                  {{ task.displayProduct.overviewPlacementDetail }}
                </div>
              </div>
              <div class="task-block-column-4">
                <div class="subproject-type d-flex">
                  <div
                    class="project-type type-flex"
                    [ngClass]="task.executedIconClass"
                  >
                    Laden
                  </div>
                  <div class="type-rest-flex"></div>
                </div>
              </div>
            </div>
            <div class="task-block-row row-flex-3">
              <div class="task-block-column-0-75">
                <div *ngIf="task.description?.length > 0">
                  <span
                    class="strong block-text notes-label"
                    [ngClass]="task.executedClass"
                    >Opmerkingen: </span
                  ><span class="block-text" [matTooltip]="task.description">{{
                    task.description | shortenText : 50
                  }}</span>
                </div>
              </div>
              <div class="task-block-column-0-25">
                <div class="executed-display">
                  <div class="executed-queue-icon">
                    <div
                      *ngIf="task.submitQueued && !task.submitInProgress"
                      matTooltip="Taak staat klaar om ingediend te worden"
                    >
                      <mat-icon class="queue-icon">cloud_queue</mat-icon>
                    </div>
                    <div
                      *ngIf="task.submitInProgress"
                      matTooltip="Taak wordt ingediend"
                    >
                      <mat-spinner
                        class="submitting-icon"
                        color="primary"
                        diameter="20"
                      ></mat-spinner>
                    </div>
                  </div>
                  <div class="executed-string">
                    <span
                      *ngIf="task.executedTimeString?.length > 0"
                      class="strong"
                      >{{ task.executedTimeString }}</span
                    >
                  </div>
                  <div class="executed-circle">
                    <mat-icon svgIcon="{{ task.executedCircle }}"></mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      class="map-container"
      *ngIf="
        taskList != null &&
        taskList.tasks?.length > 0 &&
        selectedView === SELECTABLE_VIEWS.PLACER_TOUR_MAP_VIEW
      "
    >
      <daily-planning-map
        [taskSubProjects]="subProjects"
        [addresses]="addresses"
      ></daily-planning-map>
    </div>
  </div>
</div>
